import React from "react";

import { Barber, RenderComponent } from "../../types";

interface BarberListProps {
  className?: string;
  itemClassName?: string;
  barbers: Barber[];
  loader?: React.ReactElement;
  render: (barber: Barber, index?: number) => RenderComponent;
}

const BarberList: React.FC<BarberListProps> = ({
  className,
  itemClassName,
  barbers,
  loader,
  render,
}) => {
  const hasData = !!(barbers && barbers.length);

  return (
    <div className={className}>
      {!hasData
        ? loader
        : barbers.map((barber, index) => {
            return (
              <div key={index} className={itemClassName}>
                {render(barber)}
              </div>
            );
          })}
    </div>
  );
};

export default BarberList;
